import PropTypes from "prop-types";
import React from "react";
import ReactTooltip from "react-tooltip";

import { createClassNameString } from "../utils";

import "./styles.scss";

export const Popover = ({
  backgroundColor,
  border,
  borderColor,
  children,
  className,
  effect,
  position,
  show,
  textColor,
  toolTipId,
  ...props
}) => (
  <ReactTooltip
    backgroundColor={backgroundColor}
    border={border}
    borderColor={borderColor}
    className={createClassNameString(["apti-CL apti-Popover", className])}
    effect={effect}
    id={toolTipId}
    place={position}
    textColor={textColor}
    {...props}
  >
    {children}
  </ReactTooltip>
);

Popover.propTypes = {
  backgroundColor: PropTypes.string,
  border: PropTypes.bool,
  borderColor: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  className: PropTypes.string,
  effect: PropTypes.string,
  position: PropTypes.oneOf(["left", "right", "top", "bottom"]),
  show: PropTypes.bool,
  textColor: PropTypes.string,
  toolTipId: PropTypes.string,
};

Popover.defaultProps = {
  backgroundColor: "white",
  border: true,
  borderColor: "#5B57DC",
  children: <></>,
  className: undefined,
  effect: "solid",
  position: "left",
  show: false,
  textColor: "#668391",
};
